import { isElement, merge, uniqueId, forEach } from "lodash";
import { publish } from "../../01-helpers/event-manager";
import { DROPDOWN_ } from "../../02-const/id-names";
import { DROPDOWN_CLICKED } from "../../02-const/event-names";
import Breakpoint from "../../01-helpers/breakpoint-util";

/* ========================================================================== */

const
	moduleName = 'dropdown',

	cssClass = {
		isCollapsed: 'collapsed',
		isActive: 'active',
		isClosed: 'closed',
		isOpen: 'open'
	},

    dropdownDefaultConfig = {
		selectors: {
			baseElement: `.js-${moduleName}`,
            toggle: `.js-${moduleName}-toggle`,
            menu: `.js-${moduleName}-menu`
		},
		selfClosing: true
    };

/* ========================================================================== */

export default class Dropdown {
    constructor(baseElement, config = {}) {
        if (!isElement(baseElement)) {
	        return; // throw "Unable to create instance of Dropdown, no baseElement has been provided";
        }

        const mergedConfig = merge({}, dropdownDefaultConfig, config);
		this._configure(baseElement, mergedConfig);

		if (!this._checkRequirements()) {
			return;
		}

        this._setup();
    }

    /* ====================================================================== */

    _configure(baseElement, config) {
        this.baseElement = baseElement;
        this.config = config;
        this.id = uniqueId(DROPDOWN_);
        this.toggleElement = baseElement.querySelector(config.selectors.toggle);
        this.menuElement = baseElement.querySelector(config.selectors.menu);
    }

    _checkRequirements() {
        if (!isElement(this.toggleElement) || !isElement(this.menuElement)) {
	        return false;
        }
        return true;
    }

	_setup() {
        if (Breakpoint.isDesk()) {
			return;
		}
		this._bindToggleEventListener();
    }

    /* ====================================================================== */

    open() {
        this.isOpen = true;

		this.baseElement.classList.add(cssClass.isActive);

        this.toggleElement.classList.remove(cssClass.isClosed);
		this.toggleElement.classList.add(cssClass.isOpen);

        this.menuElement.classList.remove(cssClass.isCollapsed);

        this.toggleElement.blur();
    }

    close() {
        this.isOpen = false;

		this.baseElement.classList.remove(cssClass.isActive);

        this.toggleElement.classList.add(cssClass.isClosed);
		this.toggleElement.classList.remove(cssClass.isOpen);

        this.menuElement.classList.add(cssClass.isCollapsed);

        this.toggleElement.blur();
    }

    toggle() {
        if (this.isOpen) {
            return this.close();
        }

        this.open();
    }

    destroy() {
        this._unbindToggleEventListener();
    }

    /* ====================================================================== */

    _onToggleClicked(evt) {
		evt.preventDefault();

		//if (this.isOpen && this.config.selfClosing === true) {
		//	this.close();
		//} else if (!this.isOpen) {
		//	this.open();
		//}

        publish(DROPDOWN_CLICKED, { dropdownId: this.id });
    }

    _bindToggleEventListener() {
        // Since event listeners change the scope of 'this', we need to make
        // sure we are able to remove this event, so we define it before adding.
        this.boundEvent = event => this._onToggleClicked(event);

        this.toggleElement.addEventListener('click', this.boundEvent);
    }

    _unbindToggleEventListener() {
        this.toggleElement.removeEventListener('click', this.boundEvent);
    }
}

const initDropdowns = () => {
	forEach(document.querySelectorAll('.js-dropdown'), dropdownElement => {
		new Dropdown(dropdownElement);
	});
}

initDropdowns();

